import { MoreVertical } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';

import { DataTableRow, TableAction } from '../types';

interface RowActionsProps<T extends DataTableRow> {
  actions: TableAction<T>[];
  row: T;
}

export function RowActions<T extends DataTableRow>({ actions, row }: RowActionsProps<T>) {
  // Resolve per-row gating: hidden actions are dropped, disabled ones stay but can't be clicked.
  const visibleActions = actions.filter((action) => !action.isHidden?.(row));

  if (visibleActions.length === 0) return null;

  return (
    <div className="flex items-center gap-1">
      {visibleActions.slice(0, 2).map((action) => (
        <Button
          key={action.id}
          type="button"
          variant="outline"
          size="icon"
          className="h-9 w-9"
          disabled={action.isDisabled?.(row)}
          onClick={() => action.onClick?.(row)}>
          {action.icon && <action.icon className="w-4 h-4" />}
        </Button>
      ))}

      {visibleActions.length > 2 && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button type="button" variant="ghost" size="icon" className="h-9 w-9">
              <MoreVertical className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            {visibleActions.slice(2).map((action) => (
              <DropdownMenuItem
                key={action.id}
                disabled={action.isDisabled?.(row)}
                onClick={() => action.onClick?.(row)}>
                {action.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
}
